import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import * as axios from 'axios';
import { applicationStatusText, applicationStatusIcon, Role, ApplicationStatus, applicationChoiceTemplateTypeText, ApplicationChoiceType, emailTypeText } from './utilities/enums';
import { colors } from './utilities/colors';

Vue.config.productionTip = false

// ---------- AXIOS ----------
axios.defaults.baseURL = process.env.VUE_APP_API;
// the token is set in the store commit.
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(
    function (response) {
        // let rights = response.headers["x-proxy-rights"];
        // // that.$store.commit("rights", rights);
        // return response;

        // console.log(response);
        return response;
    },
    function (error) {

        if (error.response.status == 401) {
            // debugger;
            // that.snackbar.show;
            // that.snackbar.showLogout();
            store.dispatch("logout");
            router.push({ name: "login" });
        }

        // return error;
        // debugger;
        store.commit("snackbar", { show: true, text: `${error.response.status}: ${error.response.data}`, color: "error" });
        return Promise.reject(error.response);



        // if (error.response.status == 403) {
        //     let user = error.response.data.user;
        //     if (user) {
        //         that.$store.commit("rights", user.rights);
        //     }

        //     that.snackbar.showInsufficientUserRights();

        //     // that.$store.dispatch('logout');
        //     // that.$router.push('/login');
        // } else {
        //     return Promise.reject(error);
        // }
    }
);
// ---------- AXIOS ----------

// ---------- COMPONENTS ----------
import Brreg from './components/Brreg';
Vue.component('Brreg', Brreg);

import NewUser from './components/NewUser';
Vue.component('NewUser', NewUser);

import ChangeStatus from './components/ChangeStatus';
Vue.component('ChangeStatus', ChangeStatus);

import Users from './components/Users';
Vue.component('Users', Users);

import Payment from './components/Payment';
Vue.component('Payment', Payment);

import Report from './components/Report';
Vue.component('Report', Report);

import EditUser from './components/EditUser';
Vue.component('EditUser', EditUser);

import ApplicationSummary from './components/ApplicationSummary';
Vue.component('ApplicationSummary', ApplicationSummary);

import ApplicationSearchByDateYear from './components/ApplicationSearchByDateYear.vue'
Vue.component('ApplicationSearchByDateYear', ApplicationSearchByDateYear);

import CurrencyTextField from "./components/CurrencyTextField";
Vue.component("CurrencyTextField", CurrencyTextField);
// ---------- COMPONENTS ----------

// ---------- HANDLEBARS ----------
import * as moment from "moment";
import * as handlebars from "handlebars";
handlebars.registerHelper("datetime", function() {
    return moment().format("YYYY-MM-DD HH:mm");
});
handlebars.registerHelper("date", function() {
    return moment().format("YYYY-MM-DD");
});
// ---------- HANDLEBARS ----------

new Vue({
    router,
    store,
    vuetify,
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    render: h => h(App)
}).$mount('#app')

// ---------- MIXINS ----------
Vue.mixin({
    methods: {
        colors: () => colors,
        applicationStatusText: applicationStatusText,
        applicationStatusIcon: applicationStatusIcon,
        role: () => Role,
        applicationStatus: () => ApplicationStatus,
        applicationChoiceTemplateTypeText: applicationChoiceTemplateTypeText,
        applicationChoiceTemplateType: () => ApplicationChoiceType,
        emailTypeText: emailTypeText
    }
});
// ---------- MIXINS ----------